var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.353553","y1":"0.646447","x2":"4.35355","y2":"4.64645","stroke":"black","key":0}),React.createElement("line",{"y1":"-0.5","x2":"5.65685","y2":"-0.5","transform":"matrix(-0.707107 0.707107 0.707107 0.707107 8 1)","stroke":"black","key":1})]);
}

ChevronDown.defaultProps = {"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
